import { useState } from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import moment from 'moment';
import { FaCheck, FaTrash } from 'react-icons/fa';

const InfoPaiement = ({ adherent, handleValidePaid }) => {

    const nbPaiement = [1, 2, 3, 4, 5, 6]
    const [date1, setDate1] = useState(moment(adherent.date_paiement_num_1, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    const [date2, setDate2] = useState(moment(adherent.date_paiement_num_2, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    const [date3, setDate3] = useState(moment(adherent.date_paiement_num_3, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    const [date4, setDate4] = useState(moment(adherent.date_paiement_num_4, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    const [date5, setDate5] = useState(moment(adherent.date_paiement_num_5, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    const [date6, setDate6] = useState(moment(adherent.date_paiement_num_6, 'DD/MM/YYYY').format('YYYY-MM-DD'));

    const handleDate = (date, num) => {
        console.log(date, num)
        switch (num) {
            case 1: setDate1(date); break;
            case 2: setDate2(date); break;
            case 3: setDate3(date); break;
            case 4: setDate4(date); break;
            case 5: setDate5(date); break;
            case 6: setDate6(date); break;
            default: break;
        }
    }

    const handleValide = (paid_id, num) => {
        //console.log('handleValide', paid_id, num, num === 1 ? date1 : num === 2 ? date2 : num === 3 ? date3 : num === 4 ? date4 : num === 5 ? date5 : date6)
        handleValidePaid(paid_id, num===1?date1:num===2?date2:num===3?date3:num===4?date4:num===5?date5:date6 );
    }
    return (
        <Card>

            <Card.Header><h3>Paiement</h3></Card.Header>
            <Card.Body>
                <h4>Adhésion le {moment(adherent.date_creation).format("DD/MM/YYYY")}</h4>

                {adherent.montant === 0 && adherent.montant_ffc === 0 && adherent.montant_tribu === 0 ?
                    (<>
                        <p>Aucun réglement attendu cette année</p>
                        {adherent.cotisation_id2 === 7 && <p>Adhésion effectué une année précédente car <b>paiement pour 3 ans</b> </p>}
                    </>) :
                    (<>
                        <Table striped bordered hover style={{ margin: 'auto', textAlign: 'center' }}>
                            <thead>
                                <tr>
                                    <th>Cotisation FFC</th>
                                    <th>Règlement Tribu</th>
                                    <th>Règlement SIV</th>
                                    <th>Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td >{adherent.montant_ffc}</td>
                                    <td >{adherent.montant_tribu}</td>
                                    <td >{adherent.montant_siv}</td>
                                    <td >{adherent.montant_total}</td>
                                </tr>
                            </tbody>
                        </Table>
                    </>)
                }


                <br />
                <Table striped bordered hover style={{ margin: 'auto', textAlign: 'center', }}>
                    <thead>
                        <tr>
                            <th></th>
                            <th>Montant</th>
                            <th>Date</th>
                            <th>Validé</th>
                        </tr>
                    </thead>
                    <tbody>
                        {nbPaiement.map((i) => {
                            if (adherent[`montant_num_${i}`] > 0) {
                                return (
                                    <tr>
                                        <td >{i}</td>
                                        <td >{adherent[`montant_num_${i}`]}</td>
                                        {/* <td >{adherent[`date_paiement_num_${i}`]}</td> */}
                                        <td ><input
                                            type="date"
                                            name="duedate"
                                            placeholder="Due date"
                                            value={i===1?date1:i===2?date2:i===3?date3:i===4?date4:i===5?date5:date6}
                                            // value={formateDateUSFromFr(adherent[`date_paiement_num_${i}`])}
                                            onChange={(e) => handleDate(e.target.value, i)}
                                        /></td>
                                        <td >{adherent[`validated_num_${i}`] === 1 ? <div variant='success'>
                                            <FaCheck />
                                            <Button variant='outline-danger' size='sm' onClick={() => handleValide(adherent[`paid_id_num_${i}`], i)}><FaTrash />
                                            </Button></div> : <Button variant='primary' onClick={() => handleValide(adherent[`paid_id_num_${i}`], i)}><FaCheck />
                                        </Button>}</td>
                                    </tr>
                                )
                            }
                        })}

                        <tr>
                            <th >Total</th>
                            <th >{adherent.montant_total}</th>
                            <th ></th>
                            <th >{adherent.somme_paid}</th>
                        </tr>
                    </tbody>
                </Table>
            </Card.Body>
        </Card >
    );
}

export default InfoPaiement;
